import AppLayout from "@/layouts/app/AppLayout";

import dashboard from "./dashboard"

export default [
  

  {
    path: "/sponsor",
    component: AppLayout,
    meta: {
      middleware: ["auth"],
      roles: ["sponsor"],
    },
    children: [
        ...dashboard,
    ],
  },
];
